import { Controller } from "stimulus"

export default class extends Controller {
  close() {
    const flashMessage = document.querySelector('.flash-messages')

    flashMessage.style.display = 'none';
  }
}
